import { useLang } from "@/i18n/LanguageContext";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

export default function ReportDetails({ onUpload }) {
  const { t } = useLang();
  const d = t.reportDetails;

  return (
    <section id="report-details" data-testid="report-details" className="scroll-mt-28 bg-zinc-50 py-20 md:py-28">
      <div className="container-x">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
          >
            <span className="overline">{d.overline}</span>
            <h2 className="mt-4 text-4xl text-zinc-900 md:text-[48px] md:leading-[1.05]">{d.title}</h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-zinc-600">
              {d.description}
              <br />
              <br />
              {d.indicated}
            </p>
            <div className="mt-8 grid grid-cols-3 gap-3">
              {[
                { value: d.stat1Value, label: d.stat1Label },
                { value: d.stat2Value, label: d.stat2Label },
                { value: d.stat3Value, label: d.stat3Label },
              ].map((stat, i) => (
                <div
                  key={i}
                  className="rounded-2xl border border-zinc-200 bg-white p-4 text-center shadow-sm"
                  data-testid={`report-stat-${i}`}
                >
                  <span className="block text-2xl font-semibold text-[color:var(--sentinel)] md:text-3xl">
                    {stat.value}
                  </span>
                  <span className="mt-1 block text-[11px] leading-snug text-zinc-500">{stat.label}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="rounded-[28px] border border-zinc-200 bg-white p-8 shadow-[0_24px_60px_-40px_rgba(81,75,186,0.25)]"
          >
            <h3 className="flex items-center gap-2 text-lg font-semibold text-zinc-900">
              <span className="h-2 w-2 rounded-full bg-[color:var(--sentinel)]" />
              {d.systemsTitle}
            </h3>
            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {d.systems.map((system) => (
                <li key={system} className="flex items-center gap-2.5 text-sm text-zinc-700">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-[color:var(--sentinel)]" />
                  {system}
                </li>
              ))}
            </ul>
            <div className="mt-8 flex justify-end border-t border-zinc-100 pt-6">
              <button type="button" onClick={onUpload} className="btn-primary" data-testid="report-details-cta">
                {d.cta}
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
